import { render, staticRenderFns } from "./ProductImageSlider.vue?vue&type=template&id=711ae6da&scoped=true&"
import script from "./ProductImageSlider.vue?vue&type=script&lang=js&"
export * from "./ProductImageSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProductImageSlider.vue?vue&type=style&index=0&id=711ae6da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711ae6da",
  null
  
)

export default component.exports